import React, { useState } from "react";

const Tooltip = ({ width, className, content, children }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleTouchStart = () => {
    setIsVisible(true);
  };

  const handleTouchEnd = () => {
    setIsVisible(false);
  };

  return (
    <div
      className="relative inline-block group"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onMouseEnter={handleTouchStart}
      onMouseLeave={handleTouchEnd}
    >
      {children}
      <div
        className={`${className} opacity-0 invisible group-hover:opacity-100 group-hover:visible ${isVisible ? 'opacity-100 visible' : ''} transition-all duration-300 absolute bg-gray-500/90 text-center text-white text-sm px-2 py-1 rounded-md transform -translate-x-1/2 -translate-y-2 z-[100]`}
        style={{ width: width}}
      >
        {content}
      </div>
    </div>
  );
};

export default Tooltip;
